rjm.ui.ChartBuilderBlockableView = Backbone.View.extend(
  unblock: ->
    @$el.removeClass "blocked"

  block: ->
    @$el.addClass "blocked"
)